import { render, staticRenderFns } from "./noticesearch.vue?vue&type=template&id=38785946&scoped=true"
import script from "./noticesearch.vue?vue&type=script&lang=js"
export * from "./noticesearch.vue?vue&type=script&lang=js"
import style0 from "./noticesearch.vue?vue&type=style&index=0&id=38785946&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38785946",
  null
  
)

export default component.exports